import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Mobility = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Mobility</h1>
                <p className="colorWht">Our Mobility solutions help you make informed and intelligent decisions to achieve better business results.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/mobility.jpg" alt="mobility" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Collaboration, connectivity and communication are the need of the hour for organizations. It is a constant endeavor to improve employee interactivity and create seamless experiences for customers while having real-time engagements with the field force. Mobility is redefining the rules of user experience with anytime, anywhere availability and is now a necessity for future-ready, borderless global enterprise.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside mobility">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/applications" title="Applications">Applications</Link></li>
                  <li><Link to="/enterprise-resource-planning" title="ERP">ERP</Link></li>
                  <li><Link to="/consulting" title="Consulting">Consulting</Link></li>
                  <li><Link to="/business-process" title="Business Process">Business Process</Link></li>
                  <li><Link to="/gps-tracking-service" title="GPS Tracking as Service">GPS Tracking as Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>How Green Orange Helps?</h2>
                <p>
                  Our Mobility solutions help you make informed and intelligent decisions to achieve better business results. We enable you to experience a connected ecosystem centred on:
                </p>
                <ul>
                  <li>Employee Services - for productivity improvement (up to 30%) through simple workflows and optimized processes</li>
                  <li>Field services - for seamless and affordable access to business critical information anywhere, anytime</li>
                  <li>Consumer services - for a unique customer experience through intuitive and personal interactions across touch points</li>
                </ul>
                <h4>Pillars of the Enterprise</h4>
                <ul>
                  <li>Employees</li>
                  <li>Field Force</li>
                  <li>Consumers</li>
                </ul>
                <h4>Areas Covered</h4>
                <ul>
                  <li>Mobility Consulting</li>
                  <li>Managed Mobility Services</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Mobility;

